/**
 * Capacitor native bridge — active only inside the Android/iOS app built by
 * mobile/build_app.py, which loads this site from its live URL. A no-op in a
 * browser.
 */
import { App } from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";

export const isNative = () => !!window.Capacitor?.isNativePlatform?.();

const HOME_KEY = "las_native_home";

/**
 * The page a native app starts on, e.g. "/t/acme" or "/t/acme/seller". Each
 * app is built for one tenant; this is recorded from the first page it loads
 * and used to keep the app inside that tenant. null in a browser.
 */
export function nativeHome() {
  if (!isNative()) return null;
  let home = sessionStorage.getItem(HOME_KEY);
  if (!home) {
    const match = window.location.pathname.match(/^\/t\/[^/]+(\/seller)?/);
    if (!match) return null;
    home = match[0];
    sessionStorage.setItem(HOME_KEY, home);
  }
  return home;
}

export async function initNativeBridge() {
  if (!isNative()) return;
  nativeHome();

  // Android back button: go back in history, or leave the app from its first screen.
  try {
    await App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else App.minimizeApp();
    });
  } catch (e) { /* plugin not available */ }
}

/** Call once the app has rendered — hides the native splash screen. */
export function onAppReady() {
  if (!isNative()) return;
  SplashScreen.hide({ fadeOutDuration: 300 }).catch(() => {});
}
